export const GET_SAML_VERIFICATION_SUCCESS =
  'app/containers/Auth/SamlCallback/GET_SAML_VERIFICATION_SUCCESS';
export const GET_SAML_VERIFICATION_FAILED =
  'app/containers/Auth/SamlCallback/GET_SAML_VERIFICATION_FAILED';
